<template>
    <div class="h-100" style="overflow: auto">
        <div v-for="favType of ['bookmark','Saved Search']" :key="favType">
            <div class="pb-2 m-4 d-flex" style="border-bottom: 1px solid #242424;position:relative;font-size: 14px;margin-bottom: 0px !important;">
                <svg v-if="foldedFavTypes.includes(favType)" @click="foldOrUnFoldFavTypes(favType)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill fold-unfold-icons" viewBox="0 0 16 16">
                    <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                </svg>
                <svg v-if="!foldedFavTypes.includes(favType)" @click="foldOrUnFoldFavTypes(favType)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill fold-unfold-icons" viewBox="0 0 16 16">
                    <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                </svg>
                <template v-if="favType=='bookmark'">{{$t('Bookmarks')}}</template>
                <template v-else>{{$t('Saved Search')}}</template>
            </div>
            <div v-if="!foldedFavTypes.includes(favType)" class="mt-2 value-style d-inline-flex bg-transparent rounded text-light input-fields searched-metadata-display-fields" style="padding-bottom: 15px !important;">
                <ul class="tags-display-ul p-0 w-100 m-0 ml-4" style=" display: grid;">
                    <div style="display: grid;">
                            <li v-for="eachFav of favoritesList.filter(op=>op.type==favType)" :key="eachFav._id"
                                @dblclick="renameFav(eachFav)" style="position:relative;inset-inline-end:5px">
                                <div class="list-group-item view-tags" style="color:#EEEEEE">
                                    <div class="screen-tags-name-display">
                                        <div>
                                            <div v-if="eachFav.cover_photo" style="height: 29px;width: 27px;">
                                                <img :src="getProxyConvertedURL(eachFav.cover_photo)" style="height:100%;width:100%;border-radius: 7px;">
                                            </div>
                                            <template v-else>
                                                <svg v-if="favType == 'bookmark'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#9c9c9c" class="bi bi-bookmark" viewBox="0 0 16 16">
                                                    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/>
                                                </svg>
                                                <template v-else>
                                                    <svg xmlns="http://www.w3.org/2000/svg" style="height: 24px ;width: 24px;" fill="currentColor" class="bi bi-folder" viewBox="0 0 16 16">
                                                        <path d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zM2.19 4a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4H2.19zm4.69-1.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707z"/>
                                                    </svg>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-search"
                                                        style="height: 12px;width: 15px;inset-inline-start:18px;position: absolute;bottom: 19px;border-radius: 10px;background: #15181B;" viewBox="0 0 16 16">
                                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                                    </svg>
                                                </template>
                                            </template>
                                        </div>
                                        <div style="margin-inline-start: 5px !important" class="screens-name-styles">{{ eachFav.name }}</div>
                                    </div>
                                    <div class="screen-tags-styles">
                                        <edit-icon @click.native="renameFav(eachFav)"
                                           style="float: inline-end;text-align: end;margin:8px;height:25px !important;width:25px !important"
                                           title="Rename">
                                        </edit-icon>
                                        <deleteIcon @click.native="deleteFav(eachFav)"
                                           style="float: inline-end;text-align: end;margin:8px;height:26px !important;width:16px !important"
                                           title="Delete">
                                        </deleteIcon>
                                    </div>
                                </div>
                            </li>
                    </div>
                </ul>
            </div>
        </div>
        <editBookMark v-if="editBookMark" :newFav="false" :favInfo="activeFavEntry" @close="editBookMark=false"></editBookMark>
    </div>
</template>


<script>
import { mapActions,mapGetters,mapMutations } from "vuex";
import Utils from "../../components.utils.js"
import {NotifierConstants} from "../../components.constants.js";
import EditIcon from "../core/InlineEditField.vue";
import editBookMark from "./AddOrEditBookMark.vue";
import deleteIcon from "../core/InlineDeleteIcon.vue";

export default {
    data() {
        return {
            activeFavEntry:{},
            favoritesList:[],
            foldedFavTypes:[],
            editBookMark:false
        };
    },
    components:{
        "edit-icon": EditIcon,
        editBookMark,
        deleteIcon
    },
    methods : {
        getProxyConvertedURL(url){
              return Utils.convertToLoginIPDomainName(url);
        },
        foldOrUnFoldFavTypes(favType){
            if(this.foldedFavTypes.includes(favType)){
                this.foldedFavTypes = this.foldedFavTypes.filter(op=>op!=favType)
            }else{
                if(!this.foldedFavTypes.includes(favType)){
                    this.foldedFavTypes.push(favType)
                }
            }
        },
        deleteFav(favInfo){
            if(confirm(`Are you sure you want to delete "${favInfo.name}"`)){
                let payload = {params:{_id:favInfo._id}}
                this.deleteExistingFavorite(payload).then((data) => {
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        if (data.message.includes("Failed")) {
                            this.$toast.warning(`Failed to delete ${favInfo.type} "${favInfo.name}"`);
                        } else {
                            this.$toast.success(`${favInfo.type} "${favInfo.name}" deleted successfully.`);
                        }
                    }else {
                        this.$toast.error(data.message);
                    }
                });
            }
        },
        handleFavNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message && notification.message.user_id == this.getLoggedInUserId()){
                let favInfo = notification.message
                if(notification.message_type == NotifierConstants.favoriteRemovedNotification){
                    this.favoritesList = this.favoritesList.filter(op=>op._id != favInfo._id)
                }else if(notification.message_type == NotifierConstants.favoriteModifiedNotification){
                    let indx = this.favoritesList.findIndex(op=>op._id == favInfo._id)
                    if(indx >= 0){
                        this.$set(this.favoritesList[indx], "name", favInfo.name)
                        if('cover_photo' in favInfo){
                            this.$set(this.favoritesList[indx], "cover_photo", Utils.convertToLoginIPDomainName(favInfo.cover_photo))
                        }
                    }
                }else if(notification.message_type == NotifierConstants.favoriteCreatedNotification){
                    this.favoritesList.push(favInfo)
                }
            }
        },
        renameFav(favInfo){
            this.activeFavEntry = favInfo;
            this.editBookMark = true;
        },
        refreshFavList(){
            let payload = {params:{user_id:this.getLoggedInUserId()}}
            this.favoritesList =[]
            this.getAllFavoritesFromServer(payload).then((data) => {
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.favoritesList = data.favorites
                }
            });
        },
        ...mapActions("favorites",["getAllFavoritesFromServer","deleteExistingFavorite"]),
        ...mapGetters("users",["getLoggedInUserId"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    },
    created(){
        this.addWSEventListener({
            eventname:[NotifierConstants.favoriteCreatedNotification, NotifierConstants.favoriteModifiedNotification, NotifierConstants.favoriteRemovedNotification],
            callback:this.handleFavNotification,
            parent:"ShowFavorites"})
        this.refreshFavList()
    },
    beforeDestroy(){
        this.removeWSEventListener({
            eventname:[NotifierConstants.favoriteCreatedNotification, NotifierConstants.favoriteModifiedNotification, NotifierConstants.favoriteRemovedNotification],
            callback:this.handleFavNotification,
            parent:"ShowFavorites"})
    }
}
</script>


<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $border-on-hover: 1px solid #61707d;

    .input-fields{
        border: none;
        border-radius: 0px !important;
    }
    .searched-metadata-display-fields{
    height: auto;
    width: 82%;
    overflow:auto;
    }
    .tags-display-ul{
    list-style-type: none;
    }
    .tags-display-ul .show-tags-delete {
    visibility: hidden;
    }

    .tags-display-ul li:hover .show-tags-delete {
    visibility: visible;
    }
    .list-group-item {
    width:80%;
    }
    .view-tags {
        font-size: 12px!important;
        display: inline-flex!important;
        margin: 6px!important;
        border-radius: 15px!important;
        text-align: start;
        padding: 7px!important;
        justify-content: space-between;
        background:$primary-background;
        border:$border-color;
    span {
        margin-inline-start: 0px !important;
        font-size: 12px !important;
        border-radius: 15px !important;
        position: relative !important;
        top: 1px !important;
        width: 90%;
    }
    }
    .show-main-tag-delete {
    margin-inline-start: 5px;
    margin-inline-end: 5px;
    }

    .view-tags:hover, .view-sub-tags:hover {
    border: $border-on-hover !important;
    }

    .view-tags .show-main-tag-delete, .more-actions-btn {
    visibility: hidden;
    }

    .view-tags:hover{
    border: $border-color !important;
    .show-main-tag-delete, .more-actions-btn {
        visibility: visible;
    }
    } 
    .screen-tags-name-display{
    display:inline-flex;
    line-height:44px;
    width:33%;
    }
    .screen-tags-styles{
    display:inline-flex;
    .view-sub-tags{
        font-size: 12px!important;
        height: 30px;
        display: inline-flex!important;
        margin: 5px!important;
        border: $border-color!important;
        border-radius: 15px!important;
        min-width: 50px!important;
        padding: 0!important;
        text-align: start;
        width: auto!important;
        padding-inline-start: 12px!important;
        justify-content: start;
        padding-top: 2px!important;
        span {
        margin-inline-start: 0!important;
        font-size: 12px!important;
        border-radius: 15px!important;
        position: relative!important;
        top: 3px!important;
        width: 90%;
        }
        .show-tags-delete{
        margin: 3px!important;
        float: inline-end;
        text-align: end;
        width: 25px;
        height: 25px;
        color: $text-color;
        position: relative;
        bottom: 4px;
        }
    }
    }
    .screens-name-styles{
        width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }/* width */
    ::-webkit-scrollbar {
        width: 8px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }
    .fold-unfold-icons{
        padding: 0px 6px 6px 6px;
        height: 28px;
        width: 28px;
        border-radius: 4px;
        color: rgb(119, 119, 119);
    }
    .fold-unfold-icons:hover{
        background: #d1d2d31a;
    }
</style>